import React, { Dispatch, FC, useState } from "react";

import { FormControl, Grid, OutlinedInput, Popover } from "@mui/material";
import { PopoverOrigin } from "@mui/material/Popover/Popover";
import { styled } from "@mui/material/styles";

import { IgButton } from "./IgButton";

const PREFIX = "BasePopover";

const classes = {
  dragIcon: `${PREFIX}-dragIcon`,
  row: `${PREFIX}-row`,
  dragBurgerIcon: `${PREFIX}-dragBurgerIcon`,
};

const Root = styled("div")(({ theme }) => ({
  [`& .${classes.dragIcon}`]: {
    color: "rgba(0,0,0,0.38)",
    transform: "rotate(90deg)",
    "&:hover, &:focus": {
      color: "#0013BC",
      transform: "rotate(90deg) scale(1.25)",
    },
  },

  [`& .${classes.row}`]: {
    backgroundColor: "white",
  },

  [`& .${classes.dragBurgerIcon}`]: {
    marginTop: "4px",
    "&:hover, &:focus": {
      color: "#0013BC",
      transform: "scale(1.25)",
    },
  },
}));

interface BasePopoverProps {
  index: number;
  itemKey: string;
  onSaveClick: (index: number) => void;
  value: string;
  onValueChange:
    | Dispatch<React.SetStateAction<string>>
    | ((value: string) => void);
  valuePlaceholder?: string;
  rootComponent: any;
  anchorOrigin?: PopoverOrigin;
  transformOrigin?: PopoverOrigin;
  disabled?: boolean;
}

/**
 * @see Popover
 */
export const IgPopover: FC<BasePopoverProps> = ({
  index,
  itemKey,
  onSaveClick,
  value,
  onValueChange,
  valuePlaceholder,
  rootComponent,
  anchorOrigin,
  transformOrigin,
  disabled,
}) => {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const popoverId = open ? `${itemKey}-popover-${index}` : undefined;

  return (
    <Root>
      <span onClick={disabled ? undefined : handleClick}>{rootComponent}</span>
      <Popover
        id={popoverId}
        open={open}
        anchorEl={anchorEl}
        elevation={0}
        onClose={handleClose}
        anchorOrigin={
          anchorOrigin || {
            vertical: "bottom",
            horizontal: "left",
          }
        }
        transformOrigin={
          transformOrigin || {
            vertical: "top",
            horizontal: "left",
          }
        }
        slotProps={{
          paper: {
            sx: {
              minHeight: "25px",
              minWidth: "200px",
              padding: "5px",
            },
          },
        }}
      >
        <Grid
          container
          direction={"column"}
          rowSpacing={1}
          alignItems={"center"}
        >
          <Grid item>
            <FormControl style={{ width: "100%" }} size={"small"}>
              <OutlinedInput
                id={`${itemKey}-input`}
                placeholder={valuePlaceholder}
                value={value}
                onChange={(e) => onValueChange(e.target.value)}
                onKeyDown={(e) => e.stopPropagation()}
              />
            </FormControl>
          </Grid>
          <Grid item>
            <IgButton
              size={"small"}
              onClick={() => {
                onSaveClick(index);
                handleClose();
              }}
            >
              Save
            </IgButton>
          </Grid>
        </Grid>
      </Popover>
    </Root>
  );
};
